import { css } from 'styled-components';
import { scrollbarStyle } from './scrollbarStyle.js';

const scrollDirection = {
  vertical: (withCustomScrollbar = false) => css(["overflow:hidden auto;-webkit-overflow-scrolling:touch;", ";"], withCustomScrollbar && scrollbarStyle.componentScrollbar),
  horizontal: (withCustomScrollbar = false) => css(["overflow:auto hidden;-webkit-overflow-scrolling:touch;", ";"], withCustomScrollbar && scrollbarStyle.componentScrollbar)
};

export { scrollDirection };
//# sourceMappingURL=scrollDirection.js.map
